import React from 'react';
import {
  Link
} from "react-router-dom";
import Logo from '../assets/logo.png';

function Header(){
    return(
        <header className="header d-flex align-items-center justify-content-between">
          <Link to="/" className="logo"><img src={Logo} alt="logo" /></Link>
          
          <a href="/contact" className="btn border-0 btn-primary">talk to us</a>
        </header>
    )
}

export default Header;